export const ugovor_o_uskladištenju = {
    templateId: 203,
    category: 13,
    templateTitle: "Ugovor o uskladištenju",
    templateDescription: `<p>.</p>`,
    description: `

  `,

    sides: [
        {
            signature: 'Skladištar:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Posl. subjekt / Ime i prezime',        
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    placeholder: "Zastupa (za pr. osobe)",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija (za pr. osobe)",
                    inSignature: true,
                }],
            suffix: ' (u daljnjem tekstu: Skladištar)',
            delimiter: `i`
        },
        {
            signature: 'Ostavodavac:',
            inputs: [{
                type: 'input',
                required: true,
                placeholder: 'Posl. subjekt / Ime i prezime',
            },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Ulica i kućni broj',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'Mjesto',
                },
                {
                    type: 'input',
                    required: true,
                    placeholder: 'OIB',
                },
                {
                    type: "input",
                    placeholder: "Zastupa (za pr. osobe)",
                    inSignature: true,
                  },
                  {
                    type: "input",
                    placeholder: "Funkcija (za pr. osobe)",
                    inSignature: true,
                }
            ],
            suffix: ' (u daljnjem tekstu: Ostavodavac),'
        }
    ],
 
    
    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O USKLADIŠTENJU',
    noArticleNumbers: false,

    articles: [

    
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/203_ugovor_o_uskladištenju.ts